// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#navbar {
  background-color: white;
  height: 60px !important;
  position: fixed !important;
  top: 0px !important;
  width: 100% !important;
  border-bottom: 1px solid rgb(200, 200, 200);
  z-index: 999;
}

#navbar-container {
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/css/components/navbar.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd","sourcesContent":["#navbar {\n  background-color: white;\n  height: 60px !important;\n  position: fixed !important;\n  top: 0px !important;\n  width: 100% !important;\n  border-bottom: 1px solid rgb(200, 200, 200);\n  z-index: 999;\n}\n\n#navbar-container {\n  padding-left: 10px;\n  padding-right: 10px;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
